import axios from 'axios'

axios.defaults.baseURL = "https://umbod.onrender.com/" //"http://157.157.101.180:5002/"; //"http://127.0.0.1:5000/" //"http://157.157.101.180:5002/"; //"https://magnillo.pythonanywhere.com/cars/test";
/*axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');*/
axios.defaults.headers.common['secret'] = "maggibest";
